var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.handleClose),expression:"handleClose"}],staticClass:"relative"},[_vm._t("toggle",null,{"toggle":_vm.handleToggle}),_c('div',{class:[
      'absolute right-0 z-10 w-full min-w-fit divide-y divide-gray-100 overflow-y-auto rounded bg-white shadow',
      _vm.topClass ? 'top-12' : ''
    ],style:({ width: _vm.width, top: _vm.top, bottom: _vm.bottom }),attrs:{"id":_vm.id}},[(_vm.visible)?_vm._t("content",null,{"close":_vm.handleClose}):_vm._e()],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }